import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Baner, BanerResponse, BanerState } from "./BanerType";
import { fetchLargeBanersThunk, fetchSmallBanersThunk } from "./baners.actions";

export const fetchLargeBaners = createAsyncThunk(
  "baners/fetchLargeBaners",
  fetchLargeBanersThunk
);
export const fetchSmallBaners = createAsyncThunk(
  "baners/fetchSmallBaners",
  fetchSmallBanersThunk
);

const initialState: BanerState = {
  large: {
    list: [],
    is_fetch: false,
  },
  small: {
    list: [],
    is_fetch: false,
  },
};

const BanersSlice = createSlice({
  name: "baners",
  initialState,
  reducers: {
    clearValues: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLargeBaners.fulfilled, (state, { payload }) => {
        return {
          ...state,
          large: {
            is_fetch: true,
            list: payload,
          },
        };
      })
      .addCase(fetchLargeBaners.pending, (state) => {
        return {
          ...state,
          large: {
            ...state.large,
            is_fetch: false,
          },
        };
      })
      .addCase(fetchLargeBaners.rejected, (state) => {
        return {
          ...state,
          large: {
            ...state.large,
            is_fetch: false,
          },
        };
      })
      .addCase(fetchSmallBaners.fulfilled, (state, { payload }) => {
        return {
          ...state,
          small: {
            is_fetch: true,
            list: payload,
          },
        };
      })
      .addCase(fetchSmallBaners.pending, (state) => {
        return {
          ...state,
          small: {
            ...state.small,
            is_fetch: false,
          },
        };
      })
      .addCase(fetchSmallBaners.rejected, (state) => {
        return {
          ...state,
          small: {
            ...state.small,
            is_fetch: false,
          },
        };
      });
  },
});

export const { clearValues } = BanersSlice.actions;
export default BanersSlice.reducer;
